import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterSearch_template} from "./filterSearch_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {filterDropdown_template} from "../../../common/js/vnKnockoutJsTemplates/filterDropdown_template";
import {filterAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterAutoComplete_template";
import {filterMultipleAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterMultipleAutoComplete_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;


export class articleAnalysis_template extends vnTemplate{

    //shared filters
    protected brandsFilter : multipleSelector_template;
    protected brandSegmentsFilter : multipleSelector_template;
    protected postIntentsFilter : multipleSelector_template;
    protected postContentTypesFilter : multipleSelector_template;
    protected networkCategoriesFilter : multipleSelector_template;
    protected datesFilter: filterDate_template;
    protected searchField: filterSimple_template;
    protected postPaymentCategoryFilter: filterSearch_template;

    //article filters
    protected ideatorsFilter: filterMultipleAutoComplete_template;
    protected brandSafetyFilter : multipleSelector_template;
    protected authorsFilter: filterMultipleAutoComplete_template;
    protected srEditorsFilter: filterMultipleAutoComplete_template;
    protected jrEditorsFilter: filterMultipleAutoComplete_template;
    protected postInitiativesFilter : multipleSelector_template;
    protected postPaymentCategorySystemFilter: multipleSelector_template
    protected primaryCategoriesFilter : filterAutoComplete_template;
    protected primaryTagFilter : filterAutoComplete_template;
    protected tagsFilter : filterAutoComplete_template;
    protected tagTypesFilter : filterAutoComplete_template;

    //video filters
    protected filterPublishedDatesDisabler: filterDropdown_template;
    protected filterPublishedDates: filterDate_template;
    protected geosFilter : multipleSelector_template;
    protected devicesFilter : multipleSelector_template;
    protected operatingSystemsFilter : multipleSelector_template;


    public validationsList: validationsList_template;
    protected pagination: pagination_template;
    protected resultsInfo: resultsInfo_template;
    protected exportDataCsv: exportDataCsv;
    public presetFilter: presetFilter_template;
    public toolTipFailure: infoButton_template;

    readonly brandSafety : Array<{id : string, name : string}> = [
        {"id": "unknown", "name": "unknown"},
        {"id": "safe", "name": "Safe"},
        {"id": "partialUnsafe", "name": "Partial Unsafe"},
        {"id": "unsafe", "name": "Unsafe"},
    ];

    readonly viewModes = [
        {"id": "article", "name": "Article"},
        {"id": "articleVideoPerformance", "name": "Article Video Performance"},
    ];

    readonly devices = [
        { "id": "mobile", "name": "Mobile"},
        { "id": "desktop", "name": "Desktop"},
        { "id": "other", "name": "Other"},
    ];

    readonly operatingSystems = [
        { "id": "Android", "name": "Android"},
        { "id": "iOS", "name": "iOS"},
        { "id": "Windows", "name": "Windows"},
        { "id": "macOS", "name": "macOS"},
        { "id": "Other", "name": "other"},
    ];

    readonly publishStatus = [
        { "id": "all", "name": "all"},
        { "id": "publish", "name": "publish"},
        { "id": "republish", "name": "republish"}
    ];

    readonly filterPublishedDatesDisablerOptions = [
        {"id": "0", "name": "Disable"},
        {"id": "1", "name": "Enable"},
    ];

    readonly contentTypesGroup : Array<{id : string, name : string}> = [
        { "id": "all", "name": "all"},
        { "id": "shortForm", "name": "Short"},
        { "id": "longForm", "name": "Long"}
    ];

    readonly articleTypes : Array<{id : string, name : string}> = [
        {"id": "all", "name": "All"},
        {"id": "regular", "name": "Regular"},
        {"id": "video", "name": "Video"},
        {"id": "thread", "name": "Thread"},
    ];

    readonly dataRanges = [
        { "id": 15, "name": "15"},
        { "id": 30, "name": "30"},
        { "id": 60, "name": "60"},
        { "id": 90, "name": "90"},
    ];

    protected getTemplateHtml(): string{

        return  /*html*/`
            <div class="sub-header w-justify">

                ${this.presetFilter.getHtmlBuild()}

                <div class="w-left">

                    <div class="dropdown select-single">
                        <label class="form-label" for="">View Mode</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: viewModeSelectedText"></button>

                        <div class="dropdown-list">
                            <div class="w-form">
                                <div class="form-group" data-bind="foreach: viewModes">
                                    <input type="radio" data-bind="checked : $parent.viewModeSelected, value: id,  attr: { 'id': 'view_' + id, 'name' : 'view_' + id }, event:{ change: $parent.onViewModeChange}">
                                    <label class="form-label" data-bind="attr: {for : 'view_' + id }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>

                    ${this.brandsFilter.getHtmlBuild()}
                    ${this.brandSegmentsFilter.getHtmlBuild()}
                    <!-- ko if: viewModeSelected() == 'article' -->
                        ${this.postInitiativesFilter.getHtmlBuild()}
                    <!-- /ko -->
                    ${this.postIntentsFilter.getHtmlBuild()}
                    ${this.postContentTypesFilter.getHtmlBuild()}

                    <div class="dropdown select-single">
                        <label class="form-label" for="">Page Type</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: articleTypeSelected"></button>
                        <div class="dropdown-list">
                            <div class="w-form">
                                <div class="form-group" data-bind="foreach: articleTypes">
                                    <input type="radio" data-bind="checked : $parent.articleTypeSelected, value: id,  attr: { 'id': 'article_type_' + id, 'name' : 'article_type_' + id }, event:{ change: $parent.onArticleTypeChange}">
                                    <label class="form-label" data-bind="attr: {for : 'article_type_' + id }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>

                    ${this.networkCategoriesFilter.getHtmlBuild()}
                    <!-- ko if: viewModeSelected() == 'article' -->
                        ${this.postPaymentCategorySystemFilter.getHtmlBuild()}
                        <div class="filter-search">
                            ${this.postPaymentCategoryFilter.getHtmlBuild()}
                        </div>

                        ${this.primaryCategoriesFilter.getHtmlBuild()}
                        ${this.primaryTagFilter.getHtmlBuild()}
                        ${this.tagsFilter.getHtmlBuild()}
                        ${this.tagTypesFilter.getHtmlBuild()}
                        ${this.srEditorsFilter.getHtmlBuild()}
                        ${this.jrEditorsFilter.getHtmlBuild()}
                        ${this.authorsFilter.getHtmlBuild()}
                        ${this.ideatorsFilter.getHtmlBuild()}
                    <!-- /ko -->
                    <!-- ko if: viewModeSelected() == 'articleVideoPerformance' -->
                        ${this.geosFilter.getHtmlBuild()}
                        ${this.devicesFilter.getHtmlBuild()}
                        ${this.operatingSystemsFilter.getHtmlBuild()}
                    <!-- /ko -->
                    ${this.datesFilter.getHtmlBuild()}

                    <div data-bind="visible: viewModeSelected() == 'article'">
                        <div class="dropdown select-single">
                        <label class="form-label" for="">data Range (days)</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: dataRangeSelected"></button>

                        <div class="dropdown-list">
                            <div class="w-form">
                                <div class="form-group" data-bind="foreach: dataRanges">
                                    <input type="radio" data-bind="checked : $parent.dataRangeSelected, value: id,  attr: { 'id': 'data_range_' + id, 'name' : 'data_range_' + id }, event:{ change: $parent.onDataRangeChange}">
                                    <label class="form-label" data-bind="attr: {for : 'data_range_' + id }, text: name"></label>
                                </div>
                            </div>

                        </div>
                    </div>
                    </div>

                    <div data-bind="visible: viewModeSelected() == 'articleVideoPerformance', css: {disabledDiv: !publishedDatePickerEnabled()}">
                        ${this.filterPublishedDates.getHtmlBuild()}
                    </div>

                    <div data-bind="visible: viewModeSelected() == 'articleVideoPerformance'">
                        <label class="form-label" for="" >Published Dates</label>
                        ${this.filterPublishedDatesDisabler.getHtmlBuild()}
                    </div>

                    <div class="dropdown select-single">
                        <label class="form-label" for="">Publishing type</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: publishStatusSelected"></button>

                        <div class="dropdown-list">
                            <div class="w-form">
                                <div class="form-group" data-bind="foreach: publishStatus">
                                    <input type="radio" data-bind="checked : $parent.publishStatusSelected, value: id,  attr: { 'id': 'pub_status_' + id, 'name' : 'pub_status_' + id }, event:{ change: $parent.onPublishStatusChange}">
                                    <label class="form-label" data-bind="attr: {for : 'pub_status_' + id }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div data-bind="visible: viewModeSelected() == 'article'" class="content-form-radio">
                        <div class="title" style="font-family:Lato, sans-serif">Form</div>
                        <form >
                            <div style="display: flex; gap:0.5rem" data-bind="foreach: formOptions">
                            <input type="radio" data-bind="checked : $parent.formOptionSelected, value: id,  attr: { 'id': 'form_' + id, 'name' : 'form_' + id }, event:{ change: $parent.onFormOptionChange}">
                            <label class="form-label" data-bind="attr: {for : 'form_' + id }, text: name"></label>
                            </div>
                        </form>

                    </div>
                     <div data-bind="visible: viewModeSelected() == 'article'">
                            ${this.brandSafetyFilter.getHtmlBuild()}
                    </div>
                </div>

            </div>

            ${this.validationsList.getHtmlBuild() }

             <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-dimensions"></div>
                   <div id="selected-brands"></div>
                   <div id="selected-brand-segments"></div>
                   <div id="selected-geos"></div>
                   <div id="selected-video-placement"></div>
                   <div id="selected-devices"></div>
                   <div id="selected-operatingSystems"></div>
                   <div id="selected-initiatives"></div>
                   <div id="selected-systems"></div>
                   <div id="selected-intents"></div>
                   <div id="selected-content_types"></div>
                   <div id="selected-network_categories"></div>
                   <div id="selected-sr-editors"></div>
                   <div id="selected-jr-editors"></div>
                   <div id="selected-authors"></div>
                   <div id="selected-ideators"></div>
                   <div id="selected-brandSafety"></div>
                </div>
            </div>

            <div class="list-header w-justify">

                <div class="w-left">
                    <h2 data-bind="visible: viewModeSelected() == 'article'" class="section-title icon i-roi">Article Analysis</h2>
                    <h2 data-bind="visible: viewModeSelected() == 'articleVideoPerformance'" class="section-title icon i-roi">Article Video Performance Analysis</h2>
                    <!-- ko if: viewModeSelected() == 'article' -->
                        <div>
                            <label class="toggle">
                                <span class="toggle-label" data-bind="css: (trafficSource() == 1) ? 'is-activated' : ''">GA4</span>
                                <input class="toggle-checkbox" data-bind="event: {change: onToggleTrafficSource}, checked: (trafficSource() == 2)" type="checkbox">
                                <div class="toggle-switch"></div>
                                <span class="toggle-label" data-bind="css: (trafficSource() == 2) ? 'is-activated' : ''">Sentinel</span>
                            </label>
                        </div>
                    <!-- /ko -->
                </div>

                <div class="w-center">
                    ${this.searchField.getHtmlBuild()}
                </div>

                <div class="w-right">
                     ${this.pagination.getHtmlBuild()}
                      <button class="btn highlight icon fix-width i-expand" type="button" data-bind="class:  collapseButtonClass(), css: {'is-hidden': (exportButtonHidden())} , text: collapseButtonText(), event: { click: onCollapseClick}">Simplify</button>
                      <button class="btn icon highlight i-export" type="button" data-bind="event: { click: exportData}, css: { 'is-hidden': exportButtonHidden }">Export</button>
                </div>
            </div>

            <div class="w-list-results" id="list-results">

                <!-- ko if: viewModeSelected() == 'article' -->
                    <table class="list-results list-sections">
                        ${this.resultsInfo.getHtmlBuild()}
                        <thead>
                            <tr>
                                <th data-bind="attr: { colspan: collapseButtonText() == 'simplify' ? 4 : 3 }" class="colgroup-0"><span>Article</span></th>
                                <th data-bind="attr: { colspan: collapseButtonText() == 'simplify' ? 14 : 7 }" class="colgroup-1 start "><span>Categorization</span></th>
                                <th data-bind="attr: { colspan: collapseButtonText() == 'simplify' ? 4 : 1 }" class="colgroup-0 start"><span>Contributors</span></th>
                                <th data-bind="attr: { colspan: collapseButtonText() == 'simplify' ? 20 : 5 }" class="colgroup-1 start"><span>Active Traffic</span></th>
                                <th data-bind="attr: { colspan: collapseButtonText() == 'simplify' ? 8 : 3 }" class="colgroup-3 start"><span>Engagement</span></th>
                                <th data-bind="visible: isFinancialDataAccessible(), attr: { colspan: collapseButtonText() == 'simplify' ? 3 : 1 }" class="colgroup-2 start"><span>Revenue</span></th>
                                <th data-bind="visible: isCostDataAccessible(), attr: { colspan: collapseButtonText() == 'simplify' ? 5 : 3 }" class="colgroup-4 start"><span>Creation Costs</span></th>
                            </tr>

                            <tr>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-0 expanded-cells"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'idArticle') }, css: { 'list-sort-desc': orderByAndDirection()=='idArticle_DESC', 'list-sort-asc': orderByAndDirection()=='idArticle_ASC' }" class="icon i-dropdown-simple">Article ID</span></th>
                                <th class="colgroup-0 sticky-col"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'articleTitle') }, css: { 'list-sort-desc': orderByAndDirection()=='articleTitle_DESC', 'list-sort-asc': orderByAndDirection()=='articleTitle_ASC' }" class="icon i-dropdown-simple">Title</span></th>
                                <th class="colgroup-0"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'datePublished') }, css: { 'list-sort-desc': orderByAndDirection()=='datePublished_DESC', 'list-sort-asc': orderByAndDirection()=='datePublished_ASC' }" class="icon i-dropdown-simple">Pub. Date</span></th>
                                <th class="colgroup-0"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'publishTypeName') }, css: { 'list-sort-desc': orderByAndDirection()=='publishTypeName_DESC', 'list-sort-asc': orderByAndDirection()=='publishTypeName_ASC' }" class="icon i-dropdown-simple">Pub. Type</span></th>

                                <th class="colgroup-1 start"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'brandShortName') }, css: { 'list-sort-desc': orderByAndDirection()=='brandShortName_DESC', 'list-sort-asc': orderByAndDirection()=='brandShortName_ASC' }" class="icon i-dropdown-simple">Brand</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 expanded-cells"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'segmentShortName') }, css: { 'list-sort-desc': orderByAndDirection()=='segmentShortName_DESC', 'list-sort-asc': orderByAndDirection()=='segmentShortName_ASC' }" class="icon i-dropdown-simple">Segment</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 expanded-cells"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'networkCategoryName') }, css: { 'list-sort-desc': orderByAndDirection()=='networkCategoryName_DESC', 'list-sort-asc': orderByAndDirection()=='networkCategoryName_ASC' }" class="icon i-dropdown-simple">Net. Cat.</span></th>
                                <th class="colgroup-1"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'primaryCategoryName') }, css: { 'list-sort-desc': orderByAndDirection()=='primaryCategoryName_DESC', 'list-sort-asc': orderByAndDirection()=='primaryCategoryName_ASC' }" class="icon i-dropdown-simple">Pri. Cat.</span></th>
                                <th class="colgroup-1"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'primaryTagName') }, css: { 'list-sort-desc': orderByAndDirection()=='primaryTagName_DESC', 'list-sort-asc': orderByAndDirection()=='primaryTagName_ASC' }" class="icon i-dropdown-simple">Pri. Tag</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 col-article-tags expanded-cells"><span>Tags</span></th>
                                <th class="colgroup-1"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'postPaymentCategoryName') }, css: { 'list-sort-desc': orderByAndDirection()=='postPaymentCategoryName_DESC', 'list-sort-asc': orderByAndDirection()=='postPaymentCategoryName_ASC' }" class="icon i-dropdown-simple">Payment Category</span></th>
                                <th class="colgroup-1"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'contentTypeName') }, css: { 'list-sort-desc': orderByAndDirection()=='contentTypeName_DESC', 'list-sort-asc': orderByAndDirection()=='contentTypeName_ASC' }" class="icon i-dropdown-simple">Content Type</span></th>
                                <th class="colgroup-1"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'intentName') }, css: { 'list-sort-desc': orderByAndDirection()=='intentName_DESC', 'list-sort-asc': orderByAndDirection()=='intentName_ASC' }" class="icon i-dropdown-simple">Intent</span></th>
                                <th class="colgroup-1"><span>AI Agents</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 expanded-cells"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'initiativeName') }, css: { 'list-sort-desc': orderByAndDirection()=='initiativeName_DESC', 'list-sort-asc': orderByAndDirection()=='initiativeName_ASC' }" class="icon i-dropdown-simple">Initiative</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 expanded-cells"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'contentTypeGroup') }, css: { 'list-sort-desc': orderByAndDirection()=='contentTypeGroup_DESC', 'list-sort-asc': orderByAndDirection()=='contentTypeGroup_ASC' }" class="icon i-dropdown-simple">Form</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 expanded-cells"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'brandSafeCheck') }, css: { 'list-sort-desc': orderByAndDirection()=='brandSafeCheck_DESC', 'list-sort-asc': orderByAndDirection()=='brandSafeCheck_ASC' }" class="icon i-dropdown-simple">Brand Safe Check</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 expanded-cells"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'postPaymentCategorySystemName') }, css: { 'list-sort-desc': orderByAndDirection()=='postPaymentCategorySystemName_DESC', 'list-sort-asc': orderByAndDirection()=='postPaymentCategorySystemName_ASC' }" class="icon i-dropdown-simple">System</span></th>

                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-0 start expanded-cells"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'ideatorName') }, css: { 'list-sort-desc': orderByAndDirection()=='ideatorName_DESC', 'list-sort-asc': orderByAndDirection()=='ideatorName_ASC' }" class="icon i-dropdown-simple">Ideator</span></th>
                                <th class="colgroup-0" data-bind="css: {'start': collapseButtonText() != 'simplify'}"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'writerName') }, css: { 'list-sort-desc': orderByAndDirection()=='writerName_DESC', 'list-sort-asc': orderByAndDirection()=='writerName_ASC' }" class="icon i-dropdown-simple">Writer</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-0 expanded-cells"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'jrEditorName') }, css: { 'list-sort-desc': orderByAndDirection()=='jrEditorName_DESC', 'list-sort-asc': orderByAndDirection()=='jrEditorName_ASC' }" class="icon i-dropdown-simple">Jr. Editor</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-0 expanded-cells"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'editorName') }, css: { 'list-sort-desc': orderByAndDirection()=='editorName_DESC', 'list-sort-asc': orderByAndDirection()=='editorName_ASC' }" class="icon i-dropdown-simple">Sr. Editor</span></th>

                                <!-- ko if: trafficSource() == 1 -->
                                    <th class="colgroup-1 align-right start"><span class="icon list-sort-none align-right start" data-bind="event: { click: onClickReorder.bind($data, 'sessions') }, css: { 'list-sort-desc': orderByAndDirection()=='sessions_DESC', 'list-sort-asc': orderByAndDirection()=='sessions_ASC' }" class="icon i-dropdown-simple">Sess.</span></th>
                                    <th class="colgroup-1 align-right"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'sessionsPerDay') }, css: { 'list-sort-desc': orderByAndDirection()=='sessionsPerDay_DESC', 'list-sort-asc': orderByAndDirection()=='sessionsPerDay_ASC' }" class="icon i-dropdown-simple">Sess/Day</span></th>
                                    <th class="colgroup-1 align-right"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'targetSessions') }, css: { 'list-sort-desc': orderByAndDirection()=='targetSessions_DESC', 'list-sort-asc': orderByAndDirection()=='targetSessions_ASC' }" class="icon i-dropdown-simple">Target Sessions</span></th>
                                <!-- /ko -->
                                <!-- ko if: trafficSource() == 2 -->
                                    <th class="colgroup-1 align-right start"><span class="icon list-sort-none align-right start" data-bind="event: { click: onClickReorder.bind($data, 'sessionsSentinel') }, css: { 'list-sort-desc': orderByAndDirection()=='sessionsSentinel_DESC', 'list-sort-asc': orderByAndDirection()=='sessions_ASC' }" class="icon i-dropdown-simple">Sess.</span></th>
                                    <th class="colgroup-1 align-right"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'sessionsPerDaySentinel') }, css: { 'list-sort-desc': orderByAndDirection()=='sessionsPerDaySentinel_DESC', 'list-sort-asc': orderByAndDirection()=='sessionsPerDaySentinel_ASC' }" class="icon i-dropdown-simple">Sess/Day</span></th>
                                    <th class="colgroup-1 align-right"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'targetSessions') }, css: { 'list-sort-desc': orderByAndDirection()=='targetSessions_DESC', 'list-sort-asc': orderByAndDirection()=='targetSessions_ASC' }" class="icon i-dropdown-simple">Target Sessions</span></th>
                                <!-- /ko -->
                                <th class="colgroup-1 align-right">
                                    <div style="display: flex;align-items: center;">
                                        <!-- ko if: trafficSource() == 1 -->
                                            <span class="list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'failureStatus') }, css: { 'list-sort-desc': orderByAndDirection()=='failureStatus_DESC', 'list-sort-asc': orderByAndDirection()=='failureStatus_ASC' }" class="icon i-dropdown-simple">Failure Status</span>
                                        <!-- /ko -->
                                        <!-- ko if: trafficSource() == 2 -->
                                            <span class="list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'failureStatusSentinel') }, css: { 'list-sort-desc': orderByAndDirection()=='failureStatusSentinel_DESC', 'list-sort-asc': orderByAndDirection()=='failureStatusSentinel_ASC' }" class="icon i-dropdown-simple">Failure Status</span>
                                        <!-- /ko -->
                                    <div class="w-tooltips-adv pos-bottom auto-height">
                                        ${this.toolTipFailure.getHtmlBuild()}
                                    </div>
                                </th>
                                 <!-- ko if: trafficSource() == 1 -->
                                    <th class="colgroup-1 align-right"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'pageviews') }, css: { 'list-sort-desc': orderByAndDirection()=='pageviews_DESC', 'list-sort-asc': orderByAndDirection()=='pageviews_ASC' }" class="icon i-dropdown-simple">PV</span></th>
                                <!-- /ko -->
                                <!-- ko if: trafficSource() == 2 -->
                                    <th class="colgroup-1 align-right"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'viewsSentinel') }, css: { 'list-sort-desc': orderByAndDirection()=='viewsSentinel_DESC', 'list-sort-asc': orderByAndDirection()=='viewsSentinel_ASC' }" class="icon i-dropdown-simple">PV</span></th>
                                <!-- /ko -->

                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'discoverClicks') }, css: { 'list-sort-desc': orderByAndDirection()=='discoverClicks_DESC', 'list-sort-asc': orderByAndDirection()=='discoverClicks_ASC' }" class="icon i-dropdown-simple">Discover Clicks</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'discoverImpressions') }, css: { 'list-sort-desc': orderByAndDirection()=='discoverImpressions_DESC', 'list-sort-asc': orderByAndDirection()=='discoverImpressions_ASC' }" class="icon i-dropdown-simple">Discover Imp.</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'discoverCTR') }, css: { 'list-sort-desc': orderByAndDirection()=='discoverCTR_DESC', 'list-sort-asc': orderByAndDirection()=='discoverCTR_ASC' }" class="icon i-dropdown-simple">Discover CTR</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'searchClicks') }, css: { 'list-sort-desc': orderByAndDirection()=='searchClicks_DESC', 'list-sort-asc': orderByAndDirection()=='searchClicks_ASC' }" class="icon i-dropdown-simple">Search Clicks</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'searchImpressions') }, css: { 'list-sort-desc': orderByAndDirection()=='searchImpressions_DESC', 'list-sort-asc': orderByAndDirection()=='searchImpressions_ASC' }" class="icon i-dropdown-simple">Search Imp.</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'searchCTR') }, css: { 'list-sort-desc': orderByAndDirection()=='searchCTR_DESC', 'list-sort-asc': orderByAndDirection()=='searchCTR_ASC' }" class="icon i-dropdown-simple">Search CTR</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'facebookClicks') }, css: { 'list-sort-desc': orderByAndDirection()=='facebookClicks_DESC', 'list-sort-asc': orderByAndDirection()=='facebookClicks_ASC' }" class="icon i-dropdown-simple">Facebook Clicks</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'xClicks') }, css: { 'list-sort-desc': orderByAndDirection()=='xClicks_DESC', 'list-sort-asc': orderByAndDirection()=='xClicks_ASC' }" class="icon i-dropdown-simple">X Clicks</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'linkedinClicks') }, css: { 'list-sort-desc': orderByAndDirection()=='linkedinClicks_DESC', 'list-sort-asc': orderByAndDirection()=='linkedinClicks_ASC' }" class="icon i-dropdown-simple">LinkedIn Clicks</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'instagramClicks') }, css: { 'list-sort-desc': orderByAndDirection()=='instagramClicks_DESC', 'list-sort-asc': orderByAndDirection()=='instagramClicks_ASC' }" class="icon i-dropdown-simple">Instagram Clicks</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'sessionsSentinelUS') }, css: { 'list-sort-desc': orderByAndDirection()=='sessionsSentinelUS_DESC', 'list-sort-asc': orderByAndDirection()=='sessionsSentinelUS_ASC' }" class="icon i-dropdown-simple">Sessions US</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'sessionsSentinelCA') }, css: { 'list-sort-desc': orderByAndDirection()=='sessionsSentinelCA_DESC', 'list-sort-asc': orderByAndDirection()=='sessionsSentinelCA_ASC' }" class="icon i-dropdown-simple">Sessions CA</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'sessionsSentinelAU') }, css: { 'list-sort-desc': orderByAndDirection()=='sessionsSentinelAU_DESC', 'list-sort-asc': orderByAndDirection()=='sessionsSentinelAU_ASC' }" class="icon i-dropdown-simple">Sessions AU</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'sessionsSentinelGB') }, css: { 'list-sort-desc': orderByAndDirection()=='sessionsSentinelGB_DESC', 'list-sort-asc': orderByAndDirection()=='sessionsSentinelGB_ASC' }" class="icon i-dropdown-simple">Sessions GB</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'sessionsSentinelOther') }, css: { 'list-sort-desc': orderByAndDirection()=='sessionsSentinelOther_DESC', 'list-sort-asc': orderByAndDirection()=='sessionsSentinelOther_ASC' }" class="icon i-dropdown-simple">Sessions Other</span></th>

                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-3 start align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'wordCount') }, css: { 'list-sort-desc': orderByAndDirection()=='wordCount_DESC', 'list-sort-asc': orderByAndDirection()=='wordCount_ASC' }" class="icon i-dropdown-simple">Word Count</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-3 align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'timeliness') }, css: { 'list-sort-desc': orderByAndDirection()=='timeliness_DESC', 'list-sort-asc': orderByAndDirection()=='timeliness_ASC' }" class="icon i-dropdown-simple">Turnaround Time</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-3 align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'sourceTimeliness') }, css: { 'list-sort-desc': orderByAndDirection()=='sourceTimeliness_DESC', 'list-sort-asc': orderByAndDirection()=='sourceTimeliness_ASC' }" class="icon i-dropdown-simple">Source Timeliness</span></th>
                                <th class="colgroup-3 align-right" data-bind="css: {'start': collapseButtonText() != 'simplify'}"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'usPageViewsRatio') }, css: { 'list-sort-desc': orderByAndDirection()=='usPageViewsRatio_DESC', 'list-sort-asc': orderByAndDirection()=='usPageViewsRatio_ASC' }" class="icon i-dropdown-simple">US Act. Visits</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-3 align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'mobilePageViewsRatio') }, css: { 'list-sort-desc': orderByAndDirection()=='mobilePageViewsRatio_DESC', 'list-sort-asc': orderByAndDirection()=='mobilePageViewsRatio_ASC' }" class="icon i-dropdown-simple">Mobile Act. Visits</span></th>
                                <th data-bind="visible: collapseButtonText() == 'simplify'" class="colgroup-3 align-right expanded-cells"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'desktopPageViewsRatio') }, css: { 'list-sort-desc': orderByAndDirection()=='desktopPageViewsRatio_DESC', 'list-sort-asc': orderByAndDirection()=='desktopPageViewsRatio_ASC' }" class="icon i-dropdown-simple">Desktop Act. Visits</span></th>
                                <th class="colgroup-3 align-right"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'viewAvgEngagedDepthPercentage') }, css: { 'list-sort-desc': orderByAndDirection()=='viewAvgEngagedDepthPercentage_DESC', 'list-sort-asc': orderByAndDirection()=='viewAvgEngagedDepthPercentage_ASC' }" class="icon i-dropdown-simple">Depth %</span></th>
                                <th class="colgroup-3 align-right"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'viewAvgEngagedSeconds') }, css: { 'list-sort-desc': orderByAndDirection()=='viewAvgEngagedSeconds_DESC', 'list-sort-asc': orderByAndDirection()=='viewAvgEngagedSeconds_ASC' }" class="icon i-dropdown-simple">AVD</span></th>

                                <th class="colgroup-2 align-right start expanded-cells" data-bind="visible: isFinancialDataAccessible() && collapseButtonText() == 'simplify'"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'cpm') }, css: { 'list-sort-desc': orderByAndDirection()=='cpm_DESC', 'list-sort-asc': orderByAndDirection()=='cpm_ASC' }" class="icon i-dropdown-simple">CPM</span></th>

                                <th class="colgroup-2 align-righ expanded-cells" data-bind="visible: isFinancialDataAccessible() && collapseButtonText() == 'simplify'"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'rpm') }, css: { 'list-sort-desc': orderByAndDirection()=='rpm_DESC', 'list-sort-asc': orderByAndDirection()=='rpm_ASC' }" class="icon i-dropdown-simple">RPM</span></th>

                                <th class="colgroup-2 align-right" data-bind="visible: isFinancialDataAccessible(), css: {'start': collapseButtonText() != 'simplify'}"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'revenue') }, css: { 'list-sort-desc': orderByAndDirection()=='revenue_DESC', 'list-sort-asc': orderByAndDirection()=='revenue_ASC' }" class="icon i-dropdown-simple">Revenue</span></th>

                                <th class="colgroup-4 align-right start" data-bind="visible: isCostDataAccessible()"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'pppCost') }, css: { 'list-sort-desc': orderByAndDirection()=='pppCost_DESC', 'list-sort-asc': orderByAndDirection()=='pppCost_ASC' }" class="icon i-dropdown-simple">PPP</span></th>
                                <th class="colgroup-4 align-right" data-bind="visible: isCostDataAccessible()"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'ppsCost') }, css: { 'list-sort-desc': orderByAndDirection()=='ppsCost_DESC', 'list-sort-asc': orderByAndDirection()=='ppsCost_ASC' }" class="icon i-dropdown-simple">Writer PPS</span></th>
                                <th class="colgroup-4 align-right" data-bind="visible: isCostDataAccessible()"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'writerCost') }, css: { 'list-sort-desc': orderByAndDirection()=='writerCost_DESC', 'list-sort-asc': orderByAndDirection()=='writerCost_ASC' }" class="icon i-dropdown-simple">Writer Cost Total</span></th>
                                <th class="colgroup-4 align-right expanded-cells" data-bind="visible: isCostDataAccessible() && collapseButtonText() == 'simplify'"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'ppeCost') }, css: { 'list-sort-desc': orderByAndDirection()=='ppeCost_DESC', 'list-sort-asc': orderByAndDirection()=='ppeCost_ASC' }" class="icon i-dropdown-simple">PPE & Editor PPS</span></th>
                                <th class="colgroup-4 align-right expanded-cells" data-bind="visible: isCostDataAccessible() && collapseButtonText() == 'simplify'"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'editorCost') }, css: { 'list-sort-desc': orderByAndDirection()=='editorCost_DESC', 'list-sort-asc': orderByAndDirection()=='editorCost_ASC' }" class="icon i-dropdown-simple">Editor Cost Total</span></th>
                            </tr>


                        </thead>
                        <tbody data-bind="foreach: articlesData">

                            <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-0 expanded-cells"><span data-bind="text: Number(idArticle)"></span></td>
                                <td class="colgroup-0 sticky-col no-wrap">
                                    <div class="w-link">
                                        <span><a class="link-emaki border" title="view in Emaki" data-bind="attr: {href: 'https://emakicms.com/brand/' + idBrand + '/articles/view/' + idArticle}" target="_blank"></a></span>
                                        <!-- ko ifnot: permalink -->
                                            <span class="truncated-title" data-bind="text: articleTitle"></span>
                                        <!-- /ko -->
                                        <!-- ko if: permalink -->
                                            <a class="icon i-ext-link truncated-title" data-bind="attr: {href: 'https://' + brandDomain + permalink, title: articleTitle}, text: articleTitle" target="_blank"></a>
                                        <!-- /ko -->
                                    </div>
                                </td>
                                <td class="colgroup-0"><span data-bind="text: formattedDate"></span></td>
                                <td class="colgroup-0"><span data-bind="text: publishTypeName"></span></td>

                                <td class="colgroup-1 start"><span data-bind="text: brandShortName"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 expanded-cells"><span data-bind="text: segmentShortName"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 expanded-cells"><span class="truncated-tag" data-bind="attr: {title: networkCategoryName},text: networkCategoryName"></span></td>
                                <td class="colgroup-1"><span class="truncated-tag" data-bind="attr: {title: primaryCategoryName},text: primaryCategoryName"></span></td>
                                <td class="colgroup-1"><span class="truncated-tag" data-bind="attr: {title: primaryTagName},text: primaryTagName"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 expanded-cells"><span class="truncated-tag-long" data-bind="attr: {title: tags},text: tags"></span></td>
                                <td class="colgroup-1"><span data-bind="text: postPaymentCategoryName"></span></td>
                                <td class="colgroup-1"><span data-bind="text: contentTypeName"></span></td>
                                <td class="colgroup-1"><span data-bind="text: intentName"></span></td>
                                <td class="colgroup-1"><span class="truncated-tag-long" data-bind="attr: {title: aiAgents}, text: aiAgents"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 expanded-cells"><span data-bind="text: initiativeName"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 expanded-cells"><span data-bind="text: contentTypeGroup"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 expanded-cells"><span data-bind="text: brandSafeCheck"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 expanded-cells"><span data-bind="text: postPaymentCategorySystemName"></span></td>

                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-0 start expanded-cells"><span data-bind="text: ideatorName"></span></td>
                                <td class="colgroup-0" data-bind="css: {'start': $parent.collapseButtonText() != 'simplify'}"><span data-bind="text: writerName"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-0 expanded-cells"><span data-bind="text: jrEditorName"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-0 expanded-cells"><span data-bind="text: editorName"></span></td>

                                <!-- ko if: $parent.trafficSource() == 1 -->
                                    <td class="colgroup-1 align-right start"><span data-bind="text: Number(sessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                    <td class="colgroup-1 align-right"><span data-bind="text: Number(sessionsPerDay).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                    <td class="colgroup-1 align-right"><span data-bind="text: Number(targetSessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                    <!-- ko if: failureStatus -->
                                        <td class="colgroup-1 align-right icon" data-bind="css: { 'success i-notice-success' : failureStatus == '0', 'failed i-notice-error': failureStatus == '1' }"></td>
                                    <!-- /ko -->
                                    <!-- ko ifnot: failureStatus -->
                                        <td class="colgroup-1 align-right icon" data-bind="css: { 'pending icon i-reschedule': failureStatus == null }"></td>
                                    <!-- /ko -->
                                    <td class="colgroup-1 align-right"><span data-bind="text: Number(pageviews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <!-- /ko -->
                                <!-- ko if: $parent.trafficSource() == 2 -->
                                    <td class="colgroup-1 align-right start"><span data-bind="text: Number(sessionsSentinel).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                    <td class="colgroup-1 align-right"><span data-bind="text: Number(sessionsPerDaySentinel).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                    <td class="colgroup-1 align-right"><span data-bind="text: Number(targetSessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                    <!-- ko if: failureStatusSentinel -->
                                        <td class="colgroup-1 align-right icon" data-bind="css: { 'success i-notice-success' : failureStatusSentinel == '0', 'failed i-notice-error': failureStatusSentinel == '1' }"></td>
                                    <!-- /ko -->
                                    <!-- ko ifnot: failureStatusSentinel -->
                                        <td class="colgroup-1 align-right icon" data-bind="css: { 'pending icon i-reschedule': failureStatusSentinel == null }"></td>
                                    <!-- /ko -->
                                    <td class="colgroup-1 align-right"><span data-bind="text: Number(viewsSentinel).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <!-- /ko -->

                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(discoverClicks).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(discoverImpressions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(discoverCTR).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(searchClicks).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(searchImpressions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(searchCTR).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(facebookClicks).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(xClicks).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(linkedinClicks).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(instagramClicks).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <!-- ko if: $parent.trafficSource() == 1 -->
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <!-- /ko -->
                                <!-- ko if: $parent.trafficSource() == 2 -->
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(sessionsSentinelUS).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(sessionsSentinelCA).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(sessionsSentinelAU).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(sessionsSentinelGB).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-1 align-right expanded-cells"><span data-bind="text: Number(sessionsSentinelOther).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <!-- /ko -->


                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-3 align-right start expanded-cells"><span data-bind="text: Number(wordCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-3 align-right expanded-cells"><span data-bind="text: timeliness"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-3 align-right expanded-cells"><span data-bind="text: sourceTimeliness"></span></td>
                                <td class="colgroup-3 align-right" data-bind="css: {'start': $parent.collapseButtonText() != 'simplify'}"><span data-bind="text: (usPageViewsRatio == '-') ? usPageViewsRatio : Number(usPageViewsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-3 align-right expanded-cells"><span data-bind="text: (mobilePageViewsRatio == '-') ? mobilePageViewsRatio : Number(mobilePageViewsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                <td data-bind="visible: $parent.collapseButtonText() == 'simplify'" class="colgroup-3 align-right expanded-cells"><span data-bind="text: (desktopPageViewsRatio == '-') ? desktopPageViewsRatio : Number(desktopPageViewsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                <td class="colgroup-3 align-right"><span data-bind="text: (viewAvgEngagedDepthPercentage == '-') ? viewAvgEngagedDepthPercentage : Number(viewAvgEngagedDepthPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                <td class="colgroup-3 align-right"><span data-bind="text: viewAvgEngagedSeconds"></span></td>

                                <td class="colgroup-2 align-right start expanded-cells" data-bind="visible: $parent.isFinancialDataAccessible() && $parent.collapseButtonText() == 'simplify'"><span data-bind="text: Number(cpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <!-- ko if: $parent.trafficSource() == 1 -->
                                    <td class="colgroup-2 align-right expanded-cells" data-bind="visible: $parent.isFinancialDataAccessible() && $parent.collapseButtonText() == 'simplify'"><span data-bind="text: Number(rpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <!-- /ko -->
                                <!-- ko if: $parent.trafficSource() == 2 -->
                                    <td class="colgroup-2 align-right expanded-cells" data-bind="visible: $parent.isFinancialDataAccessible() && $parent.collapseButtonText() == 'simplify'"><span data-bind="text: Number(rpmSentinel).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <!-- /ko -->

                                <td class="colgroup-2 align-right" data-bind="visible: $parent.isFinancialDataAccessible(), css: {'start': $parent.collapseButtonText() != 'simplify'}"><span data-bind="text: '$' + Number(revenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>

                                <td class="colgroup-4 align-right start" data-bind="visible: $parent.isCostDataAccessible()"><span data-bind="text: '$' + Number(pppCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td class="colgroup-4 align-right" data-bind="visible: $parent.isCostDataAccessible()"><span data-bind="text: '$' + Number(ppsCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td class="colgroup-4 align-right" data-bind="visible: $parent.isCostDataAccessible()"><span data-bind="text: '$' + Number(writerCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td class="colgroup-4 align-right expanded-cells" data-bind="visible: $parent.isCostDataAccessible() && $parent.collapseButtonText() == 'simplify'"><span data-bind="text: '$' + Number(ppeCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td class="colgroup-4 align-right expanded-cells" data-bind="visible: $parent.isCostDataAccessible() && $parent.collapseButtonText() == 'simplify'"><span data-bind="text: '$' + Number(editorCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            </tr>

                        </tbody>
                    </table>
                <!-- /ko -->

                <!-- ko if: viewModeSelected() == 'articleVideoPerformance' -->
                    <table class="list-results list-sections">
                        ${this.resultsInfo.getHtmlBuild()}
                        <thead>
                            <tr>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'brandName') }, css: { 'list-sort-desc': videoOrderByAndDirection()=='brandName_DESC', 'list-sort-asc': videoOrderByAndDirection()=='brandName_ASC' }" class="icon i-dropdown-simple">brand</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'segmentName') }, css: { 'list-sort-desc': videoOrderByAndDirection()=='segmentName_DESC', 'list-sort-asc': videoOrderByAndDirection()=='segmentName_ASC' }" class="icon i-dropdown-simple">segment</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'articleTitle') }, css: { 'list-sort-desc': videoOrderByAndDirection()=='articleTitle_DESC', 'list-sort-asc': videoOrderByAndDirection()=='articleTitle_ASC' }" class="icon i-dropdown-simple">title</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'videoTitle') }, css: { 'list-sort-desc': videoOrderByAndDirection()=='videoTitle_DESC', 'list-sort-asc': videoOrderByAndDirection()=='videoTitle_ASC' }" class="icon i-dropdown-simple">video title</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'intent') }, css: { 'list-sort-desc': videoOrderByAndDirection()=='intent_DESC', 'list-sort-asc': videoOrderByAndDirection()=='intent_ASC' }" class="icon i-dropdown-simple">intent</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'contentType') }, css: { 'list-sort-desc': videoOrderByAndDirection()=='contentType_DESC', 'list-sort-asc': videoOrderByAndDirection()=='contentType_ASC' }" class="icon i-dropdown-simple">content type</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'networkCategory') }, css: { 'list-sort-desc': videoOrderByAndDirection()=='networkCategory_DESC', 'list-sort-asc': videoOrderByAndDirection()=='networkCategory_ASC' }" class="icon i-dropdown-simple">net. category</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'loadCount') }, css: { 'list-sort-desc': videoOrderByAndDirection()=='loadCount_DESC', 'list-sort-asc': videoOrderByAndDirection()=='loadCount_ASC' }" class="icon i-dropdown-simple">loads</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'playCount') }, css: { 'list-sort-desc': videoOrderByAndDirection()=='playCount_DESC', 'list-sort-asc': videoOrderByAndDirection()=='playCount_ASC' }" class="icon i-dropdown-simple">plays</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'ctr') }, css: { 'list-sort-desc': videoOrderByAndDirection()=='ctr_DESC', 'list-sort-asc': videoOrderByAndDirection()=='ctr_ASC' }" class="icon i-dropdown-simple">ctr</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'playCount30sec') }, css: { 'list-sort-desc': videoOrderByAndDirection()=='playCount30sec_DESC', 'list-sort-asc': videoOrderByAndDirection()=='playCount30sec_ASC' }" class="icon i-dropdown-simple">30 sec plays</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'playCount60sec') }, css: { 'list-sort-desc': videoOrderByAndDirection()=='playCount60sec_DESC', 'list-sort-asc': videoOrderByAndDirection()=='playCount60sec_ASC' }" class="icon i-dropdown-simple">60 sec plays</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'engagedCount5secRatio') }, css: { 'list-sort-desc': videoOrderByAndDirection()=='engagedCount5secRatio_DESC', 'list-sort-asc': videoOrderByAndDirection()=='engagedCount5secRatio_ASC' }" class="icon i-dropdown-simple">Engaged Views</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'author') }, css: { 'list-sort-desc': videoOrderByAndDirection()=='author_DESC', 'list-sort-asc': videoOrderByAndDirection()=='author_ASC' }" class="icon i-dropdown-simple">author</span></th>
                            </tr>
                        </thead>
                        <tbody data-bind="foreach: articlesVideoData">
                            <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">
                            <td class=""><span data-bind="text: brandName"></span></td>
                            <td class=""><span data-bind="text: segmentShortName"></span></td>
                            <td class="">
                                <a class="icon i-ext-link" data-bind="attr: {href: permalink}, text: articleTitle" target="_blank"></a>
                            </td>
                            <td class=""><span data-bind="text: videoTitle"></span></td>
                            <td class=""><span data-bind="text: intent"></span></td>
                            <td class=""><span data-bind="text: contentType"></span></td>
                            <td class=""><span data-bind="text: networkCategory"></span></td>
                            <td class=""><span data-bind="text: Number(loadCount)"></span></td>
                            <td class=""><span data-bind="text: Number(playCount)"></span></td>
                            <td class=""><span data-bind="text: Number(ctr).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class=""><span data-bind="text: Number(playCount30sec)"></span></td>
                            <td class=""><span data-bind="text: Number(playCount60sec)"></span></td>
                            <td class=""><span data-bind="text: Number(engagedCount5secRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class=""><span data-bind="text: author"></span></td>
                            </tr>
                        </tbody>
                    </table>
                <!-- /ko -->
            </div>
            `;
    }

    protected initPartial():void{

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('articleAnalysis');

        this.brandsFilter = new multipleSelector_template("brandsFilter", this.getTemplateViewModel(), this.caller);
        this.brandsFilter.setTagContainerId('selected-brands');
        this.brandsFilter.setTagContainerCaption('Selected brands:');
        this.brandsFilter.setLabel("brands");
        this.brandsFilter.setLogoEnabled(true);

        this.brandSegmentsFilter = new multipleSelector_template("brandSegmentsFilter", this.getTemplateViewModel(), this.caller);
        this.brandSegmentsFilter.setTagContainerId('selected-brand-segments');
        this.brandSegmentsFilter.setTagContainerCaption('Selected segments:');
        this.brandSegmentsFilter.setLabel("segments");
        this.brandSegmentsFilter.setLogoEnabled(false);

        this.geosFilter = new multipleSelector_template("geosFilter", this.getTemplateViewModel(), this.caller);
        this.geosFilter.setLabel("countries");
        this.geosFilter.setTagContainerId('selected-geos');
        this.geosFilter.setTagContainerCaption('Selected geos:');

        this.devicesFilter = new multipleSelector_template("devicesFilter", this.getTemplateViewModel(), this.caller);
        this.devicesFilter.setLabel("devices");
        this.devicesFilter.setTagContainerId('selected-devices');
        this.devicesFilter.setTagContainerCaption('Selected devices:');

        this.operatingSystemsFilter = new multipleSelector_template("operatingSystemsFilter", this.getTemplateViewModel(), this.caller);
        this.operatingSystemsFilter.setLabel("Operating Systems");
        this.operatingSystemsFilter.setFilterContainerClass('margin-neg');
        this.operatingSystemsFilter.setTagContainerId('selected-operatingSystems');
        this.operatingSystemsFilter.setTagContainerCaption('Selected operating Systems:');

        this.postInitiativesFilter = new multipleSelector_template("postInitiativesFilter", this.getTemplateViewModel(), this.caller);
        this.postInitiativesFilter.setLabel("Mappings");
        this.postInitiativesFilter.setFilterContainerClass('margin-neg');
        this.postInitiativesFilter.setTagContainerId('selected-initiatives');
        this.postInitiativesFilter.setTagContainerCaption('Selected mappings:');

        this.postPaymentCategorySystemFilter = new multipleSelector_template("postPaymentCategorySystemFilter", this.getTemplateViewModel(), this.caller);
        this.postPaymentCategorySystemFilter.setLabel("System");
        this.postPaymentCategorySystemFilter.setFilterContainerClass('margin-neg');
        this.postPaymentCategorySystemFilter.setTagContainerId('selected-systems');
        this.postPaymentCategorySystemFilter.setTagContainerCaption('Selected systems:');

        this.postPaymentCategoryFilter = new filterSearch_template("postPaymentCategoryFilter",this.getTemplateViewModel(),this.caller);
        this.postPaymentCategoryFilter.setPlaceholder("Payment Category");

        this.postIntentsFilter = new multipleSelector_template("postIntentsFilter", this.getTemplateViewModel(), this.caller);
        this.postIntentsFilter.setLabel("Intents");
        this.postIntentsFilter.setFilterContainerClass('margin-neg');
        this.postIntentsFilter.setTagContainerId('selected-intents');
        this.postIntentsFilter.setTagContainerCaption('Selected intents:');

        this.postContentTypesFilter = new multipleSelector_template("postContentTypesFilter", this.getTemplateViewModel(), this.caller);
        this.postContentTypesFilter.setLabel("content types");
        this.postContentTypesFilter.setTagContainerId('selected-content_types');
        this.postContentTypesFilter.setTagContainerCaption('Selected content types:');

        this.networkCategoriesFilter = new multipleSelector_template("networkCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.networkCategoriesFilter.setLabel("network categories");
        this.networkCategoriesFilter.setTagContainerId('selected-network_categories');
        this.networkCategoriesFilter.setTagContainerCaption('Selected network categories:');

        this.primaryCategoriesFilter = new filterAutoComplete_template("primaryCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.primaryCategoriesFilter.setIsVisible(1);
        this.primaryCategoriesFilter.setPlaceHolderText("Primary Category");
        this.primaryCategoriesFilter.setIcon("i-tag-a");

        this.primaryTagFilter = new filterAutoComplete_template("primaryTagFilter", this.getTemplateViewModel(), this.caller);
        this.primaryTagFilter.setIsVisible(1);
        this.primaryTagFilter.setPlaceHolderText("Primary Tag");
        this.primaryTagFilter.setIcon("i-tag-a");

        this.tagsFilter = new filterAutoComplete_template("tagsFilter", this.getTemplateViewModel(), this.caller);
        this.tagsFilter.setIsVisible(1);
        this.tagsFilter.setPlaceHolderText("Tags");
        this.tagsFilter.setIcon("i-tag-a");

        this.tagTypesFilter = new filterAutoComplete_template("tagTypesFilter", this.getTemplateViewModel(), this.caller);
        this.tagTypesFilter.setIsVisible(1);
        this.tagTypesFilter.setPlaceHolderText("Tag Types");
        this.tagTypesFilter.setIcon("i-tag-a");

        this.ideatorsFilter = new filterMultipleAutoComplete_template("ideatorsFilter", this.getTemplateViewModel(), this.caller);
        this.ideatorsFilter.setIsVisible(1);
        this.ideatorsFilter.setPlaceHolderText("Ideator");
        this.ideatorsFilter.setIcon("i-user2");
        this.ideatorsFilter.setTagContainerId('selected-ideators');
        this.ideatorsFilter.setTagContainerCaption('Selected Ideators:');
        this.ideatorsFilter.setMinInputSuggestionLength(2);

        this.brandSafetyFilter = new multipleSelector_template("brandSafetyFilter", this.getTemplateViewModel(), this.caller);
        this.brandSafetyFilter.setLabel("Brand Safety");
        this.brandSafetyFilter.setFilterContainerClass('margin-neg');
        this.brandSafetyFilter.setTagContainerId('selected-brandSafety');
        this.brandSafetyFilter.setTagContainerCaption('Selected brand safety:');

        this.authorsFilter = new filterMultipleAutoComplete_template("authorsFilter", this.getTemplateViewModel(), this.caller);
        this.authorsFilter.setIsVisible(1);
        this.authorsFilter.setPlaceHolderText("Writer");
        this.authorsFilter.setIcon("i-user2");
        this.authorsFilter.setTagContainerId('selected-authors');
        this.authorsFilter.setTagContainerCaption('Selected Writers:');
        this.authorsFilter.setMinInputSuggestionLength(2);

        this.srEditorsFilter = new filterMultipleAutoComplete_template("srEditorsFilter", this.getTemplateViewModel(), this.caller);
        this.srEditorsFilter.setIsVisible(1);
        this.srEditorsFilter.setPlaceHolderText("Sr Editor");
        this.srEditorsFilter.setIcon("i-user2");
        this.srEditorsFilter.setTagContainerId('selected-sr-editors');
        this.srEditorsFilter.setTagContainerCaption('Selected Sr Editors:');
        this.srEditorsFilter.setMinInputSuggestionLength(2);

        this.jrEditorsFilter = new filterMultipleAutoComplete_template("jrEditorsFilter", this.getTemplateViewModel(), this.caller);
        this.jrEditorsFilter.setIsVisible(1);
        this.jrEditorsFilter.setPlaceHolderText("Jr Editor");
        this.jrEditorsFilter.setIcon("i-user2");
        this.jrEditorsFilter.setTagContainerId('selected-jr-editors');
        this.jrEditorsFilter.setTagContainerCaption('Selected Jr Editors:');
        this.jrEditorsFilter.setMinInputSuggestionLength(2);

        this.searchField = new filterSimple_template("searchField",this.getTemplateViewModel(),this.caller);

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.resultsInfo = new resultsInfo_template("resultsInfo", this.getTemplateViewModel(), this.caller);

        this.datesFilter = new filterDate_template("datesFilter", this.getTemplateViewModel(), this.caller);

        this.exportDataCsv = new exportDataCsv();

        let date = new Date();
        date.setHours(0,0,0,0);
        let firstOfMonth = new Date(date.getFullYear(),date.getMonth(), 1);

        // if it is the first day of the month, we display data from the last month
        if(date.getTime() === firstOfMonth.getTime()){

            firstOfMonth = new Date(date.getFullYear(),date.getMonth() - 1, 1);
            date.setDate(date.getDate() - 1);
        }else{

            date.setDate(date.getDate() - 1);
        }

        this.datesFilter.setDateRange(firstOfMonth, date);

        let dateEnd = new Date();
        dateEnd.setDate(dateEnd.getDate()-2);

        let dateStart = new Date();
        dateStart.setDate(dateStart.getDate()-9);

        this.filterPublishedDates = new filterDate_template("filterPublishedDates", this.getTemplateViewModel(), this.caller);
        this.filterPublishedDates.setStartPickerId('startPublishedDate');
        this.filterPublishedDates.setEndPickerId('endPublishedDate');
        this.filterPublishedDates.setDateRange(dateStart, dateEnd);

        this.filterPublishedDatesDisabler = new filterDropdown_template('filterPublishedDatesDisabler', this.getTemplateViewModel(), this.caller);
        this.filterPublishedDatesDisabler.setLabel("Disabler");

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);

        let toolTipFailureContent = `
            <p>Failure status is determined by whether an article falls below the established session threshold within the initial 30 days of publication.</p>
            <p>An article that is less than 30 days old will be considered pending.</p>
            <p>Sessions are attributed to articles if that article was the ‘Landing Page’ (i.e. first visited page) of that session.</p>
        `;
        this.toolTipFailure = new infoButton_template('toolTipFailure', this.getTemplateViewModel(), this.caller)
        this.toolTipFailure.setTitle('Failure Status');
        this.toolTipFailure.setContent(toolTipFailureContent);
    }

    protected getTemplateName(): string{

        return "articleAnalysis_template";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        return {
            viewModes                                   : ko.observableArray([])
            ,viewModeSelectedText                       : ko.observable("Article")
            ,viewModeSelected                           : ko.observable("article")
            ,formOptions                                : ko.observableArray([])
            ,formOptionSelected                         : ko.observable("all")
            ,dataRanges                                 : ko.observableArray([])
            ,dataRangeSelected                          : ko.observable(30)
            ,orderBy                                    : ko.observable("pageviews")
            ,videoOrderBy                               : ko.observable("loadCount")
            ,orderByDirection                           : ko.observable()
            ,orderByAndDirection                        : ko.observable("pageviews_DESC")
            ,videoOrderByAndDirection                   : ko.observable("loadCount_DESC")
            ,articlesData                               : ko.observableArray([])
            ,CSVArticlesData                            : ko.observableArray([])
            ,articlesVideoData                          : ko.observableArray([])
            ,CSVArticlesVideoData                       : ko.observableArray([])
            ,exportButtonHidden                         : ko.observable(1)
            ,articleStatInterval                        : ko.observable(45)
            ,isCostDataAccessible                       : ko.observable(0)
            ,isFinancialDataAccessible                  : ko.observable(0)
            ,publishStatus                              : ko.observableArray([])
            ,publishStatusSelected                      : ko.observable("all")
            ,articleTypes                               : ko.observableArray([])
            ,articleTypeSelected                        : ko.observable("all")
            ,publishedDatePickerEnabled                 : ko.observable(false)
            ,collapseButtonClass                        : ko.observable("i-expand")
            ,collapseButtonText                         : ko.observable("expand")
            ,trafficSource                              : ko.observable(2)
            ,selectedRows                               : ko.observableArray([])
            ,onFormOptionChange                         : function(data) {huit_neuf_this.onFormOptionChange(data); }
            ,onDataRangeChange                          : function(data) {huit_neuf_this.onDataRangeChange(data); }
            ,exportData                                 : function(){ huit_neuf_this.getCsvData(huit_neuf_this); }
            ,onClickReorder                             : function(value, data, event){ huit_neuf_this.onClickReorder(value, data, event); }
            ,onPublishStatusChange                      : function(data){ huit_neuf_this.onPublishStatusChange(); }
            ,onArticleTypeChange                        : function(data){ huit_neuf_this.onArticleTypeChange(); }
            ,onViewModeChange                           : function(data){ huit_neuf_this.onViewModeChange(data); }
            ,onCollapseClick                            : function(){ huit_neuf_this.onCollapseClick(); }
            ,onToggleTrafficSource                      : function(data, event){ huit_neuf_this.onToggleTrafficSource(data, event);}
            ,onClickRowClick                            : function(index, data){ huit_neuf_this.onClickRowClick(index); return true; }

        };
    }
    public onToggleTrafficSource(data, event){

        let toggleValue = this.getTemplateViewModel().trafficSource();

        if (toggleValue == 2) {

            this.getTemplateViewModel().trafficSource(1); // GA4 = 1
        }else {

            this.getTemplateViewModel().trafficSource(2); // Sentinel = 2
        }

        this.caller.getListData();
    }

    public getViewModelForRequest(){

        return {
            viewMode: this.getTemplateViewModel().viewModeSelected(),
            orderBy: this.getTemplateViewModel().orderBy(),
            videoOrderBy: this.getTemplateViewModel().videoOrderBy(),
            orderByDirection: this.getTemplateViewModel().orderByDirection(),
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection(),
            brands: this.getTemplateViewModel().brandsFilter.selectedItems(),
            brandSegments: this.getTemplateViewModel().brandSegmentsFilter.selectedItems(),
            postInitiatives: this.getTemplateViewModel().postInitiativesFilter.selectedItems(),
            postPaymentCategorySystems: this.getTemplateViewModel().postPaymentCategorySystemFilter.selectedItems(),
            postPaymentCategory: this.getTemplateViewModel().postPaymentCategoryFilter.filterKeyword(),
            postIntents: this.getTemplateViewModel().postIntentsFilter.selectedItems(),
            postContentTypes: this.getTemplateViewModel().postContentTypesFilter.selectedItems(),
            networkCategories: this.getTemplateViewModel().networkCategoriesFilter.selectedItems(),
            geos: this.getTemplateViewModel().geosFilter.selectedItems(),
            devices: this.getTemplateViewModel().devicesFilter.selectedItems(),
            operatingSystems: this.getTemplateViewModel().operatingSystemsFilter.selectedItems(),
            primaryCategory: this.getTemplateViewModel().primaryCategoriesFilter.idSelectedItem(),
            primaryCategoryName: this.getTemplateViewModel().primaryCategoriesFilter.nameSelectedItem(),
            primaryTag: this.getTemplateViewModel().primaryTagFilter.idSelectedItem(),
            primaryTagName: this.getTemplateViewModel().primaryTagFilter.nameSelectedItem(),
            tag: this.getTemplateViewModel().tagsFilter.idSelectedItem(),
            tagName: this.getTemplateViewModel().tagsFilter.nameSelectedItem(),
            tagType: this.getTemplateViewModel().tagTypesFilter.idSelectedItem(),
            tagTypeName: this.getTemplateViewModel().tagTypesFilter.nameSelectedItem(),
            srEditors: this.getTemplateViewModel().srEditorsFilter.selectedItemIds(),
            srEditorNames: this.getTemplateViewModel().srEditorsFilter.selectedItemNames(),
            jrEditors: this.getTemplateViewModel().jrEditorsFilter.selectedItemIds(),
            jrEditorNames: this.getTemplateViewModel().jrEditorsFilter.selectedItemNames(),
            authors: this.getTemplateViewModel().authorsFilter.selectedItemIds(),
            authorNames: this.getTemplateViewModel().authorsFilter.selectedItemNames(),
            ideators: this.getTemplateViewModel().ideatorsFilter.selectedItemIds(),
            ideatorNames: this.getTemplateViewModel().ideatorsFilter.selectedItemNames(),
            brandSafetyTypes: this.getTemplateViewModel().brandSafetyFilter.selectedItems(),
            keyword: this.getTemplateViewModel().searchField.filterKeyword(),
            dateFilterType: this.getTemplateViewModel().datesFilter.selectedFilter(),
            startDate: this.getTemplateViewModel().datesFilter.startDate(),
            endDate: this.getTemplateViewModel().datesFilter.endDate(),
            startDateRange: this.getTemplateViewModel().datesFilter.fromRange(),
            endDateRange: this.getTemplateViewModel().datesFilter.toRange(),
            publishedDateFilterType: this.getTemplateViewModel().filterPublishedDates.selectedFilter(),
            startPublishedDate: this.getTemplateViewModel().filterPublishedDates.startDate(),
            endPublishedDate: this.getTemplateViewModel().filterPublishedDates.endDate(),
            startPublishedDateRange: this.getTemplateViewModel().filterPublishedDates.fromRange(),
            endPublishedDateRange: this.getTemplateViewModel().filterPublishedDates.toRange(),
            enabledPublishedDates: this.getTemplateViewModel().publishedDatePickerEnabled(),
            publishStatus: this.getTemplateViewModel().publishStatusSelected(),
            articleType: this.getTemplateViewModel().articleTypeSelected(),
            pagination: this.getTemplateViewModel().pagination,
            postContentTypesGroup: this.getTemplateViewModel().formOptionSelected(),
            collapseButtonText: this.getTemplateViewModel().collapseButtonText(),
            dataRange: this.getTemplateViewModel().dataRangeSelected(),
            trafficSource: this.getTemplateViewModel().trafficSource(),

        }
    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        let container = super.build(classesToAdd);
        return container;
    }

    //build the date Picker calendar
    public buildDatePickerCalendar(){

        this.datesFilter.buildCalendar();
        this.filterPublishedDates.buildCalendar();
    }

    public setBrandFilterItems(departments){

        let groups = [];
        for ( let department of departments){

            let brands = [];
            for( let brand of department.brands){

                if(brand.segments.length > 0){

                    for(let segment of brand.segments){

                        brands.push(segment);
                    }
                }
                else{

                    brands.push(brand);
                }
            }
            let group = {"name" : department.name, "logo" : department.logo, "items" : brands};
            groups.push(group);
        }
        this.brandsFilter.setMultiSectionItems(groups);
        this.brandsFilter.setLabel('Brands');
    }

    public setBrandSegments(brandSegments){

        let groups = [];
        for (let brand of brandSegments){

            let segments = [];
            for( let segment of brand.segments){

                segments.push(segment);
            }

            let group = {"name" : brand.name, "items" : segments};
            groups.push(group);
        }
        this.brandSegmentsFilter.setMultiSectionItems(groups);
        this.brandSegmentsFilter.setLabel('Segments');
    }

    public setPostInitiativesFilterItems(items){

        for (let item of items){

            item['name'] = item['initiative'];
        }
        items.unshift({'id': 0, 'name' : 'no mappings'});
        this.postInitiativesFilter.setItems(items);
    }

    public setPostPaymentCategorySystemFilterItems(items){

        for (let item of items){

            item['name'] = item['name'];
        }
        items.unshift({'id': 0, 'name' : 'no systems'});
        this.postPaymentCategorySystemFilter.setItems(items);
    }

    public setPostIntentsFilterItems(items){

        for (let item of items){

            item['name'] = item['name'];
        }
        items.unshift({'id': 0, 'name' : 'no intents'});
        this.postIntentsFilter.setItems(items);
    }

    public setPostContentTypesFilterItems(items){

        items.unshift({id: 0, name: 'no post types', contentTypes: [{id: 0, name: 'no post types'}]});

        let groups = [];
        for (let groupedContentType of items){

            let group = {"name" : groupedContentType.name, "items" : groupedContentType.contentTypes};
            groups.push(group);
        }

        this.postContentTypesFilter.setMultiSectionItems(groups);
        this.postContentTypesFilter.setLabel('Content Types');
    }

    public setNetworkCategoriesFilterItems(items){

        items.unshift({id: 0, name: 'no network categories', networkCategories: [{id: 0, name: 'no network categories'}]});

        let groups = [];
        for (let groupedNetworkCategory of items){

            let group = {"name" : groupedNetworkCategory.name, "items" : groupedNetworkCategory.networkCategories};
            groups.push(group);
        }

        this.networkCategoriesFilter.setMultiSectionItems(groups);
        this.networkCategoriesFilter.setLabel('Network Categories');
    }

    public setGeosFilterItems(geos){

        this.geosFilter.setItems(geos);
        this.geosFilter.setLabel('Countries');
    }

    public setDeviceFilterItems(){

        this.devicesFilter.setItems(this.devices);
        this.devicesFilter.setLabel('Devices');
    }

    public setOperatingSystemsFilterItems(){

        this.operatingSystemsFilter.setItems(this.operatingSystems);
        this.operatingSystemsFilter.setLabel('Operating Systems');
    }

    public setTagsFilterItems(items){

        this.tagsFilter.setItems(items);
    }

    public setPrimaryTagFilterItems(items){

        this.primaryTagFilter.setItems(items);
    }

    public setTagTypesFilterItems(items){

        this.tagTypesFilter.setItems(items);
    }

    public setPrimaryCategoriesFilterItems(items){

        this.primaryCategoriesFilter.setItems(items);
    }

    public setSrEditorsFilterItems(items){

        for (let item of items){

            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        items.unshift({'id': 0, 'name' : 'null'});
        this.srEditorsFilter.setItems(items);
    }

    public setJrEditorsFilterItems(items){

        for (let item of items){

            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        items.unshift({'id': 0, 'name' : 'null'});
        this.jrEditorsFilter.setItems(items);
    }

    public setAuthorsFilterItems(items){

        for (let item of items){

            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        items.unshift({'id': 0, 'name' : 'null'});
        this.authorsFilter.setItems(items);
    }

    public setBrandSafetyFilterItems(){

        this.brandSafetyFilter.setItems(this.brandSafety);
    }

    public setIdeatorsFilterItems(items){

        for (let item of items){

            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        items.unshift({'id': 0, 'name' : 'null'});
        this.ideatorsFilter.setItems(items);
    }

    public setPostContentTypesGroupFilterItems(){

        this.getTemplateViewModel().formOptions(this.contentTypesGroup);
    }

    public setViewModesItems() {

        this.getTemplateViewModel().viewModes(this.viewModes);
    }

    public setPublishStatusItems(){

        this.getTemplateViewModel().publishStatus(this.publishStatus);
    }

    public setArticleTypeItems(){

        this.getTemplateViewModel().articleTypes(this.articleTypes);
    }

    public setArticleData(articlesData){

        this.getTemplateViewModel().articlesData(articlesData);
        this.showExportButton();
    }

    public setArticleVideoData(articlesVideoData){

        this.getTemplateViewModel().articlesVideoData(articlesVideoData);
        this.showExportButton();
    }

    public setPublishedDatesDisablerItems() {

        this.filterPublishedDatesDisabler.setOptions(this.filterPublishedDatesDisablerOptions);
    }

    public setCsvExportData(articlesDataForCsvExport){

        this.getTemplateViewModel().CSVArticlesData(articlesDataForCsvExport);
    }

    public setCsvExportVideoData(articlesVideoDataForCsvExport){

        this.getTemplateViewModel().CSVArticlesVideoData(articlesVideoDataForCsvExport);
    }

    public updatePagination(totalCount){

        this.pagination.setNumberItemToPaginate(totalCount);
    }

    public onClickReorder(value, data, event){

        if(this.getTemplateViewModel().viewModeSelected()=="article"){

            if(typeof data.orderBy === 'undefined'){

                data = this.getTemplateViewModel();
            }
            data.orderBy(value);
        }
        else{

            if(typeof data.videoOrderBy === 'undefined'){

                data = this.getTemplateViewModel();
            }
            data.videoOrderBy(value);
        }

        if(this.getTemplateViewModel().viewModeSelected()=="article"){

            //if column has already been sorted, flip the direction
            if (data.orderByAndDirection() === null || data.orderByAndDirection().includes(value)){

                if( data.orderByDirection() == "DESC" ){

                    data.orderByDirection("ASC");
                }
                else{

                    data.orderByDirection("DESC");
                }
            }
            else{

                //default column sort direction
                data.orderByDirection("DESC");
            }

            data.orderByAndDirection(value + "_" + data.orderByDirection());
        }
        else {

            //if column has already been sorted, flip the direction
            if (data.videoOrderByAndDirection() === null || data.videoOrderByAndDirection().includes(value)){

                if( data.orderByDirection() == "DESC" ){

                    data.orderByDirection("ASC");
                }
                else{

                    data.orderByDirection("DESC");
                }
            }
            else{

                //default column sort direction
                data.orderByDirection("DESC");
            }

            data.videoOrderByAndDirection(value + "_" + data.orderByDirection());
        }

        this.caller.listReorder();
    }

    public setResultInfo(nbResults, nbPages, execTime){

        this.resultsInfo.setExecutionTime(execTime);
        this.resultsInfo.setNbResults(nbResults);
        this.resultsInfo.setNbPages(nbPages);
    }

    private getCsvData(obj){

        this.caller.getListDataForCSV();
    }

    private exportCsvData(){

        let fileName;

        if(this.getTemplateViewModel().viewModeSelected()=="article"){

            let exportDataView = [];
            for (let exportDataRow of this.getTemplateViewModel().CSVArticlesData()) {

                let exportDataViewRow = this.getFormatedExportRow(exportDataRow);
                exportDataView.push(exportDataViewRow);
            }

            fileName = "articleAnalysis_data_" + this.datesFilter.getTemplateViewModel().startDate() + "_" + this.datesFilter.getTemplateViewModel().endDate()+ ".csv";
            this.exportDataCsv.exportToCsv(fileName, exportDataView);
        }
        else{

            fileName = "articleAnalysis_video_data_" + this.datesFilter.getTemplateViewModel().startDate() + "_" + this.datesFilter.getTemplateViewModel().endDate()+ ".csv";
            this.exportDataCsv.exportToCsv(fileName, this.getTemplateViewModel().CSVArticlesData());
        }

    }

    private getFormatedExportRow(exportDataRow) {

        let exportDataViewRow = [];

        exportDataViewRow["Article ID"] = Number(exportDataRow.idArticle).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["Title"] = exportDataRow.articleTitle;
        exportDataViewRow["SMO Title"] = exportDataRow.smoArticleTitle;
        exportDataViewRow["URL"] = 'https://' + exportDataRow.brandDomain + exportDataRow.permalink;
        exportDataViewRow["Emaki URL"] = 'https://emakicms.com/brand/' + exportDataRow.idBrand + '/articles/view/' + exportDataRow.idArticle;
        exportDataViewRow["Pub. Date"] = exportDataRow.datePublished;
        exportDataViewRow["Pub. Type"] = exportDataRow.publishTypeName;
        exportDataViewRow["Brand"] = exportDataRow.brandShortName;
        exportDataViewRow["Segment"] = exportDataRow.segmentShortName;
        exportDataViewRow["Net. Cat."] = exportDataRow.networkCategoryName;
        exportDataViewRow["Pri. Cat."] = exportDataRow.primaryCategoryName;
        exportDataViewRow["Pri. Tag"] = exportDataRow.primaryTagName;
        exportDataViewRow["Tags"] = exportDataRow.tags;
        exportDataViewRow["Payment Category"] = exportDataRow.postPaymentCategoryName;
        exportDataViewRow["Content Type"] = exportDataRow.contentTypeName;
        exportDataViewRow["Page Type"] = exportDataRow.articleType;
        exportDataViewRow["Intent"] = exportDataRow.intentName;
        exportDataViewRow["AI Agents"] = exportDataRow.aiAgents;
        exportDataViewRow["Initiative"] = exportDataRow.initiativeName;
        exportDataViewRow["Form"] = exportDataRow.contentTypeGroup;
        exportDataViewRow["Brand Safe Check"] = exportDataRow.brandSafeCheck;
        exportDataViewRow["System"] = exportDataRow.postPaymentCategorySystemName;
        exportDataViewRow["Ideator"] = exportDataRow.ideatorName;
        exportDataViewRow["Writer"] = exportDataRow.writerName;
        exportDataViewRow["Jr. Editor"] = exportDataRow.jrEditorName;
        exportDataViewRow["Sr. Editor"] = exportDataRow.editorName;

        if (this.getTemplateViewModel().trafficSource() == 1) {

            exportDataViewRow["Act. Sess."] = Number(exportDataRow.sessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["Act. Sess/Day"] = Number(exportDataRow.sessionsPerDay).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["Act. Target Sessions"] = Number(exportDataRow.targetSessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["Act. Failure Status"] = String(exportDataRow.failureStatus);
            exportDataViewRow["Act. PV"] = Number(exportDataRow.pageviews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        }
        else if (this.getTemplateViewModel().trafficSource() == 2){

            exportDataViewRow["Act. Sess."] = Number(exportDataRow.sessionsSentinel).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["Act. Sess/Day"] = Number(exportDataRow.sessionsPerDaySentinel).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["Act. Target Sessions"] = Number(exportDataRow.targetSessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["Act. Failure Status"] = String(exportDataRow.failureStatusSentinel);
            exportDataViewRow["Act. PV"] = Number(exportDataRow.viewsSentinel).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        }

        exportDataViewRow["Act. Discover Clicks"] = Number(exportDataRow.discoverClicks).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["Act. Discover Imp."] = Number(exportDataRow.discoverImpressions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["Act. Discover CTR"] = Number(exportDataRow.discoverCTR).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataViewRow["Act. Search Clicks"] = Number(exportDataRow.searchClicks).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["Act. Search Imp."] = Number(exportDataRow.searchImpressions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["Act. Search CTR"] = Number(exportDataRow.searchCTR).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["Facebook Clicks"] = Number(exportDataRow.facebookClicks).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["X Clicks"] = Number(exportDataRow.xClicks).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["LinkedIn Clicks"] = Number(exportDataRow.linkedinClicks).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["Instagram Clicks"] = Number(exportDataRow.instagramClicks).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});

        if (this.getTemplateViewModel().trafficSource() == 1) {

            exportDataViewRow["Sessions US"] = Number(0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["Sessions CA"] = Number(0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["Sessions AU"] = Number(0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["Sessions GB"] = Number(0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["Sessions Other"] = Number(0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        }
        else if (this.getTemplateViewModel().trafficSource() == 2){

            exportDataViewRow["Sessions US"] = Number(exportDataRow.sessionsSentinelUS).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["Sessions CA"] = Number(exportDataRow.sessionsSentinelCA).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["Sessions AU"] = Number(exportDataRow.sessionsSentinelAU).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["Sessions GB"] = Number(exportDataRow.sessionsSentinelGB).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["Sessions Other"] = Number(exportDataRow.sessionsSentinelOther).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        }
        exportDataViewRow["Word Count"] = Number(exportDataRow.wordCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["Turnaround Time"] = exportDataRow.timeliness;
        exportDataViewRow["Source Timeliness"] = exportDataRow.sourceTimeliness;
        exportDataViewRow["US Act. Visits"] = Number(exportDataRow.usPageViewsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
        exportDataViewRow["Mobile Act. Visits"] = Number(exportDataRow.mobilePageViewsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
        exportDataViewRow["Desktop Act. Visits"] = Number(exportDataRow.desktopPageViewsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
        exportDataViewRow["Depth %"] = Number(exportDataRow.viewAvgEngagedDepthPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
        exportDataViewRow["AVD"] = exportDataRow.viewAvgEngagedSeconds;

        if (this.getTemplateViewModel().isFinancialDataAccessible()) {

            exportDataViewRow["CPM"] = Number(exportDataRow.cpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});

            if (this.getTemplateViewModel().trafficSource() == 1) {

                exportDataViewRow["RPM"] = Number(exportDataRow.rpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            }
            else if (this.getTemplateViewModel().trafficSource() == 2) {

                exportDataViewRow["RPM"] = Number(exportDataRow.rpmSentinel).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            }

            exportDataViewRow["Revenue"] = '$' + Number(exportDataRow.revenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }

        if (this.getTemplateViewModel().isCostDataAccessible()) {

            exportDataViewRow["PPP Cost"] = '$' + Number(exportDataRow.pppCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["Writer PPS Cost"] = '$' + Number(exportDataRow.ppsCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["Writer Cost Total"] = '$' + Number(exportDataRow.writerCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["PPE & Editor PPS Cost"] = '$' + Number(exportDataRow.ppeCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["Editor Cost Total"] = '$' + Number(exportDataRow.editorCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }

        return exportDataViewRow;
    }

    public hideExportButton(){

        this.getTemplateViewModel().exportButtonHidden(1);
    }

    public showExportButton(){

        this.getTemplateViewModel().exportButtonHidden(0);
    }

    public setPermissions(isCostDataAccessible, isFinancialDataAccessible){

        this.getTemplateViewModel().isCostDataAccessible(isCostDataAccessible);
        this.getTemplateViewModel().isFinancialDataAccessible(isFinancialDataAccessible);
    }

    public setDataRangesItems(){

        this.getTemplateViewModel().dataRanges(this.dataRanges);
    }

    private onDataRangeChange(data){

        this.caller.getListData();
    }

    private onViewModeChange(selected) {

        this.getTemplateViewModel().viewModeSelectedText(selected.name);
        this.resetPageNumber();
        this.caller.getListData();
    }

    private onPublishStatusChange(){

        this.resetPageNumber();
        this.caller.getListData();
    }

    private onArticleTypeChange(){

        this.resetPageNumber();
        this.caller.getListData();
    }

    public setPublishedDatePickerEnabled(enable: boolean): void {

        this.getTemplateViewModel().publishedDatePickerEnabled(enable);
    }

    public isPublishDatesPickerEnabled(): boolean {

        let disabled = this.filterPublishedDatesDisabler.getTemplateViewModel().selectedOption();
        return (disabled != 0);
    }

    private onFormOptionChange(selectedRevenueOption){

        this.resetPageNumber();
        this.caller.getListData();
    }

    public resetPageNumber(): void {

        this.pagination.getTemplateViewModel().pageNumber(1);
    }

    public setViewModelFromRequest(params : Array<any>): void{

        this.presetFilter.setMultiSelectorPresetFilters(this.brandsFilter, params['brands']);
        this.presetFilter.setMultiSelectorPresetFilters(this.brandSegmentsFilter, params['brandSegments']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postInitiativesFilter, params['postInitiatives']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postPaymentCategorySystemFilter, params['postPaymentCategorySystems']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postIntentsFilter, params['postIntents']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postContentTypesFilter, params['postContentTypes']);
        this.presetFilter.setMultiSelectorPresetFilters(this.networkCategoriesFilter, params['networkCategories']);

        this.presetFilter.setAutocompletePresetFilter(this.primaryCategoriesFilter, params['primaryCategory'], params['primaryCategoryName']);
        this.presetFilter.setAutocompletePresetFilter(this.primaryTagFilter, params['primaryTag'], params['primaryTagName']);
        this.presetFilter.setAutocompletePresetFilter(this.tagsFilter, params['tag'], params['tagName']);
        this.presetFilter.setAutocompletePresetFilter(this.tagTypesFilter, params['tagType'], params['tagTypeName']);

        this.presetFilter.setMultipleAutocompletePresetFilter(this.srEditorsFilter, params['srEditors'], params['srEditorNames']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.jrEditorsFilter, params['jrEditors'], params['jrEditorNames']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.authorsFilter, params['authors'], params['authorNames']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.ideatorsFilter, params['ideators'], params['ideatorNames']);

        this.presetFilter.setDates(this.datesFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange']);


        if(typeof params['brandSafetyTypes'] !== 'undefined'){

            this.presetFilter.setMultiSelectorPresetFilters(this.brandSafetyFilter, params['brandSafetyTypes']);
        }

        if(typeof params['geos'] !== 'undefined'){

            this.presetFilter.setMultiSelectorPresetFilters(this.geosFilter, params['geos']);
        }

        if(typeof params['devices'] !== 'undefined'){

            this.presetFilter.setMultiSelectorPresetFilters(this.devicesFilter, params['devices']);
        }

        if(typeof params['operatingSystems'] !== 'undefined'){

            this.presetFilter.setMultiSelectorPresetFilters(this.operatingSystemsFilter, params['operatingSystems']);
        }

        if(typeof params['enabledPublishedDates'] !== 'undefined'){

            this.filterPublishedDatesDisabler.setSelectedOption(params['enabledPublishedDates'])
            this.getTemplateViewModel().publishedDatePickerEnabled(params['enabledPublishedDates']);
        }

        this.presetFilter.setDates(this.filterPublishedDates, params['publishedDateFilterType'], params['startPublishedDate'], params['endPublishedDate'], params['startPublishedDateRange'], params['endPublishedDateRange']);

        if(typeof params['dataRange'] !== 'undefined'){

            this.getTemplateViewModel().dataRangeSelected(params['dataRange'])
        }

        if(typeof params['publishStatus'] !== 'undefined'){

            this.getTemplateViewModel().publishStatusSelected(params['publishStatus']);
        }

        if(typeof params['articleType'] !== 'undefined') {

            this.getTemplateViewModel().articleTypeSelected(params['articleType']);
        }

        if(typeof params['keyword'] !== 'undefined'){

            this.searchField.getTemplateViewModel().filterKeyword(params['keyword']);
        }

        if(typeof params['postPaymentCategory'] !== 'undefined'){

            this.postPaymentCategoryFilter.getTemplateViewModel().filterKeyword(params['postPaymentCategory']);
        }

        if(typeof params['postContentTypesGroup'] !== 'undefined') {

            this.getTemplateViewModel().formOptionSelected(params['postContentTypesGroup']);
        }

        if(typeof params['viewMode'] !== 'undefined'){

            this.getTemplateViewModel().viewModeSelected(params['viewMode']);
            this.getTemplateViewModel().viewModeSelectedText(this.presetFilter.getFilterTextFromId(this.viewModes, params['viewMode']));
        }

        if(typeof params['collapseButtonText'] !== 'undefined') {

            if (params['collapseButtonText'] == 'simplify') {


                this.getTemplateViewModel().collapseButtonClass('i-simplify');
                this.getTemplateViewModel().collapseButtonText('simplify');
            } else {

                this.getTemplateViewModel().collapseButtonClass('i-expand');
                this.getTemplateViewModel().collapseButtonText('expand');
            }
        }

        if(typeof params['trafficSource'] !== 'undefined'){

            this.getTemplateViewModel().trafficSource(params['trafficSource']);
        }

        if(typeof params['orderBy'] !== 'undefined'){

            this.getTemplateViewModel().orderBy(params['orderBy']);
        }

        if(typeof params['orderByDirection'] !== 'undefined'){

            this.getTemplateViewModel().orderByDirection(params['orderByDirection']);
        }

        if(typeof params['orderByAndDirection'] !== 'undefined'){

            this.getTemplateViewModel().orderByAndDirection(params['orderByAndDirection']);
        }
    }

    private onCollapseClick(){

        if(this.getTemplateViewModel().collapseButtonText() == 'simplify'){

            this.getTemplateViewModel().collapseButtonClass('i-expand');
            this.getTemplateViewModel().collapseButtonText('expand');
        }else{

            this.getTemplateViewModel().collapseButtonClass('i-simplify');
            this.getTemplateViewModel().collapseButtonText('simplify');
        }

        this.caller.getListData();
    }

    private onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);

        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    public resetSelectedRows(){

        this.getTemplateViewModel().selectedRows([]);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/articleAnalysis_template.ts